<div class="dialog-container">
  <h2 class="dialog-title" mat-dialog-title>
    {{ data?.category ? 'Edit Folder' : 'Create Folder' }}
  </h2>

  <div mat-dialog-content>
    <!-- Icon preview using the selected icon -->
    <div class="icon-preview">
      <div class="icon-circle">
        <img [src]="getSelectedIconPath()" width="40" height="40" alt="Selected icon" class="selected-icon"/>
      </div>
    </div>

    <mat-form-field appearance="outline" class="input-field">
      <mat-label>Folder Name</mat-label>
      <input matInput [(ngModel)]="categoryName" maxlength="25" (keydown.space)="preventLeadingSpace($event)"/>
    </mat-form-field>

    <h3 class="icon-section-title">Choose Icon</h3>
    <div class="icon-grid">
      <button
        *ngFor="let mapping of iconMappings; let i = index"
        mat-icon-button
        [color]="selectedIconIndex === i ? 'primary' : ''"
        (click)="selectIcon(i)"
        class="icon-button"
        [title]="mapping.key">
         <img [src]="mapping.imagePath" width="40" height="40" alt="{{mapping.key}}">
      </button>
    </div>
  </div>
  
  <div mat-dialog-actions align="end">
    <button mat-button class="cancel-button" (click)="onCancel()">Cancel</button>
    <button mat-button class="create-button" 
            [disabled]="!categoryName || selectedIconIndex === null" 
            (click)="onSave()">
      {{ data?.category ? 'Update' : 'Create' }}
    </button>
  </div>
</div>